import { createSlice } from "@reduxjs/toolkit";
import {
  getAiWorkflowPlanById,
  updateSubscriptionCustomization,
} from "../thunks/aiWorkFlowThunks";

const initialState = {
  aiWorkflowPlanDetails: {
    plan: null,
    comments: null,
    tickets: null,
    files: null,
  },
};

const aiWorkflowPlanSlice = createSlice({
  name: "aiWorkflowPlan",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAiWorkflowPlanById.fulfilled, (state, action) => {
      console.log("action.payload.data", action.payload.data);
      const { subscription } = action.payload.data;
      const { comments, tickets, attachments } = subscription;
      state.aiWorkflowPlanDetails.plan = subscription;
      state.aiWorkflowPlanDetails.comments = comments;
      state.aiWorkflowPlanDetails.tickets = tickets;
      state.aiWorkflowPlanDetails.files = attachments;
    });
    builder.addCase(
      updateSubscriptionCustomization.fulfilled,
      (state, action) => {
        if (action.payload?.data?.subscription) {
          state.aiWorkflowPlanDetails.plan = action.payload.data.subscription;
        }
      },
    );
    //   .addCase(addAiWorkflowComment.fulfilled, (state, action) => {

    //     // direatly add comment to the comments array
    //     state.aiWorkflowPlanDetails.comments.push(action.payload.data);

    //     state.aiWorkflowPlanDetails = {
    //       plan: null,
    //       comments: ,
    //       tickets: null,
    //     };
    //   })
  },
});

export const {} = aiWorkflowPlanSlice.actions;

export default aiWorkflowPlanSlice.reducer;
